import { render, staticRenderFns } from "./ClientNew.vue?vue&type=template&id=7d84a510&scoped=true&"
import script from "./ClientNew.vue?vue&type=script&lang=js&"
export * from "./ClientNew.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=7d84a510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d84a510",
  null
  
)

export default component.exports